<template>
  <div>
    <!-- Banner -->
    <section id="banner" class="parallax">
      <div class="wrapper bg-cover">
        <div class="container">
          <div class="row mt-4">
            <div class="col-md-12">
              <div class="card filter-home">
                <div class="card-body">
                  <div
                    class="row justify-content-center"
                    style="margin-top: 15px"
                  >
                    <div class="col-md-12">
                      <label for="title">Título da Reunião</label>
                      <input
                        type="text"
                        v-model="title"
                        name="title"
                        class="form-control"
                        id=""
                        autocomplete="new-password"
                      />
                    </div>
                  </div>
                  <div
                    class="row justify-content-center"
                    style="margin-top: 25px"
                  >
                    <div class="col-md-4">
                      <div class="form-group">
                        <label for="inputPlace">Data Início</label>
                        <VueCtkDateTimePicker
                          minute-interval="30"
                          color="#4b2e8f"
                          button-now-translation="Hoje"
                          button-color="#4b2e8f"
                          :format="'YYYY-MM-DD HH:mm'"
                          no-label
                          label="Selecione..."
                          v-model="filter.date_start"
                        />
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="form-group">
                        <label for="inputPlace">Data Final</label>
                        <VueCtkDateTimePicker
                          minute-interval="30"
                          color="#4b2e8f"
                          button-now-translation="Hoje"
                          button-color="#4b2e8f"
                          :format="'YYYY-MM-DD HH:mm'"
                          no-label
                          label="Selecione..."
                          v-model="filter.date_end"
                          v-on:input="availability()"
                        />
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="form-group">
                        <label for="inputPlace">Participantes</label>
                        <vue-slider
                          :max="20"
                          :clickable="true"
                          tooltip="always"
                          v-model="filter.capacity"
                          @change="availability()"
                          style="margin-top: 29px"
                        ></vue-slider>
                      </div>
                    </div>
                  </div>

                  <div class="row justify-content-center">
                    <div class="col-md-4">
                      <div class="row justify-content-center">
                        <div class="col-md-12 mt-4 mb-2 centered">
                          <h5>Sala reservada</h5>
                        </div>
                        <div class="container-fluid">
                          <div class="row justify-content-center">
                            <!-- Room Card -->
                            <div class="col-md-12">
                              <div class="card">
                                <img
                                  class="card-img-top"
                                  :src="schedule.room.photo"
                                  alt
                                />

                                <div class="card-body">
                                  <div class="room-name">
                                    {{ schedule.room.title }}
                                    <span class="room-distance">{{
                                      schedule.room.tag
                                    }}</span>
                                  </div>
                                  <div class="room-name">
                                    <span class="room-distance2"
                                      >{{ schedule.room.floor }}º Andar</span
                                    >
                                  </div>
                                  <div class="room-info">
                                    <label>Adicionais da Sala</label>
                                    <div class="room-place">
                                      <span
                                        class="badge badge-secondary lg-badge"
                                        v-for="detail in schedule.room.details"
                                        :key="detail.id"
                                        style="padding 3px"
                                        >{{ detail.detail.title }}</span
                                      >
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="col-md-12">
                              <button
                                class="btn btn-block btn-add"
                                @click="modalRooms"
                              >
                                <i class="fas fa-edit"></i> Alterar a Sala
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-8">
                      <div class="row justify-content-center">
                        <div class="col-md-12 mt-4 mb-2 centered">
                          <h5>Participantes Adicionados</h5>
                        </div>
                        <div class="col-md-12" align="center">
                          <div class="row rowTable">
                            <div class="col-md-12" style="text-align: center">
                              <table class="table">
                                <thead>
                                  <tr>
                                    <th scope="col">Nome</th>
                                    <th scope="col">E-mail</th>
                                    <th scope="col">Presencial</th>
                                    <th></th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr
                                    v-for="(user, index) in users_added"
                                    :key="user.id"
                                  >
                                    <td>{{ user.name }}</td>
                                    <td>{{ user.email }}</td>
                                    <td>
                                      <div
                                        class="col-md-4 d-flex align-items-end"
                                      >
                                        <div class="row ml-1">
                                          <div class="">
                                            <label for="customSwitch1">
                                              <input
                                                type="checkbox"
                                                v-model="user.select_remote"
                                              />
                                            </label>
                                          </div>
                                        </div>
                                      </div>
                                    </td>
                                    <td>
                                      <button
                                        type="button"
                                        class="btn delete-btn mt-1 p-0"
                                        @click="split(index)"
                                        title="Excluir"
                                      >
                                        <i class="fas fa-trash"></i>
                                      </button>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                            <div class="com-md-1"></div>
                          </div>
                        </div>
                        <div class="col-md-4">
                          <button
                            class="btn btn-block btn-add"
                            @click="modalUsers"
                          >
                            <i class="fas fa-user-plus"></i> Novo Participante
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>

                  <section v-if="hidden">
                    <div class="row justify-content-center">
                      <div class="col-md-12" align="center">
                        <label for="details">Adicionais para busca</label>
                      </div>
                      <div
                        class="col-md-2 lg-check"
                        style="text-align: center"
                        v-for="detail in details"
                        :key="detail.id"
                      >
                        <input
                          class="custom-check"
                          type="checkbox"
                          :value="detail.id"
                          v-model="checkeds"
                          :id="detail.id"
                          @change="clear()"
                        />
                        <label :for="detail.id">
                          {{ detail.title }}
                        </label>
                      </div>
                    </div>

                    <hr />
                    <div class="col-md-12">
                      <button
                        class="btn btn-block btn-add"
                        @click="getAvailableRooms"
                      >
                        Buscar
                        <i class="fas fa-search"></i>
                      </button>
                    </div>
                  </section>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section id="rooms" align="center" style="margin-top: 15px">
      <div class="row justify-content-center">
        <div class="col-md-4" align="center">
          <button
            class="btn btn-block btn-add"
            style="width: 250px"
            @click="save"
          >
            <i class="fas fa-save mr-1"></i>
            Salvar Alterações
          </button>
        </div>
      </div>
    </section>
    <section class="mb-5">
      <div id="modalUsers" class="modal fade" tabindex="-1" role="dialog">
        <div class="modal-dialog modal-lg" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Convidar pessoas para esta reserva.</h5>
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Fechar"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <div class="row" v-if="is_organization">
                <div class="col-md-12">
                  <label for="add"
                    >Selecione uma pessoa de sua organização:</label
                  >
                  <v-select
                    :options="users"
                    label="name"
                    id="add"
                    v-model="new_user"
                    style="text-align: center"
                  />
                </div>
              </div>
              <br />

              <div class="row">
                <div class="col-md-12" align="center" v-if="is_organization">
                  <span style="text-align: center"
                    ><a href="#" @click="isOrganization(false)"
                      >Esta pessoa é de fora da minha organização.</a
                    ></span
                  >
                </div>
                <div class="col-md-12" align="center" v-if="!is_organization">
                  <span style="text-align: center"
                    ><a href="#" @click="isOrganization(true)"
                      >Esta pessoa é da minha organização.</a
                    ></span
                  >
                </div>
              </div>
              <br />
              <div class="row" v-if="!is_organization">
                <div class="col-md-12">
                  <label for="add"
                    >Para adicionar uma pessoa de fora de sua organização,
                    informe o <strong>Nome</strong> e
                    <strong>E-mail</strong> desta pessoa:</label
                  >
                </div>
              </div>
              <div class="row mb-3" v-if="!is_organization">
                <div class="col-md-6">
                  <input
                    type="text"
                    class="form-control"
                    v-model="new_outer_name"
                    placeholder="Nome"
                  />
                </div>
                <div class="col-md-6">
                  <input
                    type="text"
                    class="form-control"
                    v-model="new_outer_mail"
                    placeholder="E-mail"
                  />
                </div>
              </div>
              <div class="row">
                <div class="col-md-12" align="center">
                  <button
                    class="btn btn-block btn-add"
                    style="width: 250px"
                    @click="addUser"
                  >
                    Adicionar Participante
                    <i class="fas fa-user"></i>
                  </button>
                </div>
              </div>

              <div
                class="row"
                style="margin-top: 25px; margin-bottom: 10px"
                v-if="users_added.length > 0"
              >
                <div class="col-md-12">
                  <h5>Participantes Adicionados</h5>
                </div>

                <div class="col-md-12" align="center">
                  <div class="row rowTable">
                    <div class="col-md-12" style="text-align: center">
                      <table class="table">
                        <thead>
                          <tr>
                            <th scope="col">Nome</th>
                            <th scope="col">E-mail</th>
                            <th scope="col">Presencial</th>
                            <th></th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="(user, index) in users_added"
                            :key="user.id"
                          >
                            <td>{{ user.name }}</td>
                            <td>{{ user.email }}</td>
                            <td>
                              <div class="col-md-4 d-flex align-items-end">
                                <div class="row ml-1">
                                  <div class="">
                                    <label for="customSwitch1">
                                      <input
                                        type="checkbox"
                                        v-model="user.select_remote"
                                      />
                                    </label>
                                  </div>
                                </div>
                              </div>
                            </td>
                            <td>
                              <button
                                type="button"
                                class="btn delete-btn mt-1 p-0"
                                @click="split(index)"
                                title="Excluir"
                              >
                                <i class="fas fa-trash"></i>
                              </button>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <div class="com-md-1"></div>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button
                type="button"
                class="btn btn-secondary"
                data-dismiss="modal"
              >
                Fechar
              </button>
              <button
                type="button"
                class="btn btn-primary"
                data-dismiss="modal"
              >
                Salvar mudanças
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
    <div
      class="modal fade"
      id="modalServices"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">
              Selecione aqui os serviços adicionais que você deseja para sua
              reunião.
            </h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="col-md-4 d-flex align-items-end">
              <div class="row ml-1">
                <div
                  class="custom-control custom-switch"
                  v-for="services_additional in services_additionals"
                  :key="services_additional.id"
                >
                  <input
                    type="checkbox"
                    class="custom-control-input"
                    :id="services_additional.id"
                    :value="services_additional.id"
                    v-model="checkeds_services"
                  />
                  <label
                    class="custom-control-label"
                    :for="services_additional.id"
                    >{{ services_additional.title }}</label
                  >
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-add col-md-12"
              data-dismiss="modal"
            >
              Confirmar
            </button>
          </div>
        </div>
      </div>
    </div>
    <div
      class="modal fade"
      id="modalRooms"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Alterar sala</h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="alert alert-info alert-dismissible">
              <a href="#" class="close" data-dismiss="alert" aria-label="close"
                >&times;</a
              >
              <strong>Informativo!</strong> O filtro de salas é automático,
              basta apenas alterar os parâmetros desejados e as salas serão
              filtradas automaticamente.
            </div>
            <div class="row justify-content-center">
              <div class="col-md-4">
                <div class="form-group">
                  <label for="inputPlace">Data Início</label>
                  <VueCtkDateTimePicker
                    minute-interval="30"
                    color="#4b2e8f"
                    button-now-translation="Hoje"
                    button-color="#4b2e8f"
                    :format="'YYYY-MM-DD HH:mm'"
                    no-label
                    label="Selecione..."
                    v-model="filter.date_start"
                    v-on:input="getAvailableRooms()"
                  />
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group">
                  <label for="inputPlace">Data Final</label>
                  <VueCtkDateTimePicker
                    minute-interval="30"
                    color="#4b2e8f"
                    button-now-translation="Hoje"
                    button-color="#4b2e8f"
                    :format="'YYYY-MM-DD HH:mm'"
                    no-label
                    label="Selecione..."
                    v-model="filter.date_end"
                    v-on:input="getAvailableRooms()"
                  />
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group">
                  <label for="inputPlace">Participantes</label>
                  <vue-slider
                    :max="20"
                    :clickable="true"
                    tooltip="always"
                    v-model="filter.capacity"
                    style="margin-top: 29px"
                    @change="getAvailableRooms()"
                  ></vue-slider>
                </div>
              </div>
            </div>
            <div class="row justify-content-center">
              <div class="col-md-12" align="center">
                <label for="details">Filtrar por adicionais:</label>
              </div>
              <div
                class="col-2 lg-check"
                style="text-align: center"
                v-for="detail in details"
                :key="detail.id"
              >
                <input
                  class="custom-check"
                  type="checkbox"
                  :value="detail.id"
                  v-model="checkeds"
                  :id="'A' + detail.id"
                  @change="getAvailableRooms()"
                />
                <label :for="'A' + detail.id">
                  {{ detail.title }}
                </label>
              </div>
            </div>

            <section
              id="rooms"
              class="mt-3"
              v-if="loaded && available_rooms.length > 0"
            >
              <div class="row justify-content-center">
                <span class="title justify-content-center">
                  Encontramos {{ available_rooms.length }} sala{{
                    available_rooms.length > 1
                      ? "s disponíveis para você!"
                      : " disponível para você!"
                  }}
                </span>
              </div>
              <div class="container-fluid">
                <div class="row justify-content-center">
                  <!-- Room Card -->
                  <div
                    class="col-md-4"
                    v-for="room in available_rooms"
                    :key="room.id"
                  >
                    <a class="card-link pointer" @click="checkRoom(room)">
                      <div
                        class="card card-room"
                        :class="
                          room.id == selectedRoom.id ? 'borderSelected' : ''
                        "
                      >
                        <img class="card-img-top" :src="room.photo" alt />
                        <div class="card-body" style="background-color: #fff">
                          <div class="room-name">
                            {{ room.title }}
                            <span class="room-distance">{{ room.tag }}</span>
                          </div>
                          <div class="room-name">
                            <span class="room-distance2"
                              >{{ room.floor }}º Andar</span
                            >
                          </div>
                          <div class="room-info">
                            <label>Adicionais da Sala</label>
                            <div class="room-place">
                              <span
                                class="badge badge-secondary lg-badge"
                                v-for="detail in room.details"
                                :key="detail.id"
                                style="padding 3px"
                                >{{ detail.detail.title }}</span
                              >
                            </div>
                          </div>
                        </div>
                      </div>
                    </a>
                  </div>
                </div>
              </div>
            </section>
            <section
              id="rooms"
              class="mt-3"
              align="center"
              v-if="loaded && available_rooms.length <= 0"
            >
              <span class="title"
                >Nenhuma sala disponível nestes critérios</span
              >
            </section>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-add col-md-12"
              data-dismiss="modal"
              @click="changeRoom"
            >
              Confirmar
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import vSelect from "vue-select";

export default {
  data: function () {
    return {
      title: "",
      available_rooms: [],
      companies: [],
      filter: {
        date_start: "2022-01-31 18:00",
        date_end: "2022-01-31 21:00",
      },
      filters: {
        company: "",
      },
      schedule: {
        room: {
          photo: "",
        },
      },
      hidden: false,
      return: [],
      details: [],
      checkeds: [],
      services_additionals: [],
      checkeds_services: [],
      users: [],
      users_added: [],
      new_user: "",
      loaded: false,
      selectedRoom: "",
      is_organization: true,
      new_outer_mail: "",
      new_outer_name: "",
      select_remote: false,
    };
  },
  components: { vSelect },
  methods: {
    isOrganization(status) {
      this.is_organization = status;
    },
    modalUsers() {
      $("#modalUsers").modal({
        show: true,
      });
    },
    modalRooms() {
      this.getAvailableRooms();
      $("#modalRooms").modal({
        show: true,
      });
    },
    modalServices() {
      $("#modalServices").modal({
        show: true,
      });
    },
    changeRoom() {
      const self = this;
      self.schedule.room = this.selectedRoom;
    },
    addUser() {
      if (this.is_organization) {
        this.new_user.select_remote = false;
        this.users_added.push(this.new_user);
        this.new_user = "";
      } else {
        this.new_user = {
          email: this.new_outer_mail,
          name: this.new_outer_name,
          select_remote: false,
        };
        this.users_added.push(this.new_user);
        this.new_outer_mail = "";
        this.new_outer_name = "";
      }
    },
    split(index) {
      this.users_added.splice(index, 1);
    },
    availability() {
      let self = this;
      let api = self.$store.state.api + "availability_room/";

      self.filter.room_id = self.schedule.room.id;
      self.filter.reserve_id = self.schedule.id;

      self.$http
        .post(api, self.filter)
        .then((response) => {})
        .catch((error) => {
          self.errors = error.response.data;
          swal({
            title:
              "A sala reservada atualmente, não está disponível neste período selecionado.",
            text: "Deseja selecionar uma nova sala?",
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: "#DD6B55",
            confirmButtonText: "Sim, deletar!",
            showLoaderOnConfirm: true,
            buttons: {
              catch: {
                text: "Não",
                value: "cancel",
                className: "btn-danger",
              },
              confirm: {
                text: "Sim",
                value: "confirm",
              },
            },
          }).then((value) => {
            switch (value) {
              case "cancel":
                swal(
                  "Cancelado",
                  "Ok, você não poderá seguir com a alteração desta reserva.",
                  "info"
                );
                break;

              case "confirm":
                self.modalRooms();
            }
          });
        });
    },
    checkRoom: function (id) {
      this.selectedRoom = id;
    },

    mkData: function () {
      const self = this;
      let fd = new FormData();

      fd.append("title", self.title);
      fd.append("date_start", self.filter.date_start);
      fd.append("date_end", self.filter.date_end);
      fd.append("room_id", self.schedule.room.id);
      self.users_added.forEach((user_added, index) => {
        fd.append("users_added[" + index + "][name]", user_added.name);
        fd.append("users_added[" + index + "][email]", user_added.email);
        fd.append(
          "users_added[" + index + "][select_remote]",
          user_added.select_remote
        );
      });
      self.checkeds_services.forEach((checkeds_services, index) => {
        fd.append("aditional_services[" + index + "]", checkeds_services);
      });

      fd.append("_method", "put");
      return fd;
    },

    save: function () {
      let self = this;
      let id = self.$route.params.id;
      let api = self.$store.state.api + "schedule_rooms/" + id;

      let fd = self.mkData();

      self.$http
        .post(api, fd)
        .then((response) => {
          self.$message("Sucesso", "Reserva alterada com sucesso", "success");
          this.$router.push("/schedule_rooms");
        })
        .catch((error) => {
          self.errors = error.response.data;
          self.$message(null, self.errors, "error");
        });
    },

    makeFormData: function () {
      const self = this;
      let fd = new FormData();

      fd.append("date_start", self.filter.date_start);
      fd.append("date_end", self.filter.date_end);
      fd.append("capacity", self.filter.capacity);
      fd.append("details", self.checkeds);

      return fd;
    },
    getAvailableRooms: function () {
      // this.clear();
      let self = this;
      let id = self.$route.params.id;
      let api = self.$store.state.api + "available_rooms/";

      let fd = self.makeFormData();

      self.$http
        .post(api, fd)
        .then((response) => {
          self.available_rooms = response.data;
          this.loaded = true;
        })
        .catch((error) => {
          self.errors = error.response.data;
          self.$message(null, self.errors, "error");
        });
    },
    getDetails: function () {
      let self = this;
      let id = self.$route.params.id;
      let api = self.$store.state.api + "room_details/";

      let fd = self.makeFormData();

      self.$http
        .get(api, fd)
        .then((response) => {
          self.details = response.data.data;
        })
        .catch((error) => {
          self.errors = error.response.data;
          self.$message(null, self.errors, "error");
        });
    },
    getUsers: function () {
      let self = this;
      let api = self.$store.state.api + "users/?paginated=false";

      self.$http
        .get(api)
        .then((response) => {
          self.users = response.data.data;
        })
        .catch((error) => {
          self.errors = error.response.data;
          self.$message(null, self.errors, "error");
        });
    },
    getEntity: function () {
      let self = this;
      let id = self.$route.params.id;
      let api =
        self.$store.state.api +
        "schedule_rooms/" +
        id +
        "?with[]=participants&with[]=room";

      self.$http
        .get(api)
        .then((response) => {
          self.return = response.data.data[0];
          self.title = self.return.title;
          self.filter.date_start = self.return.date_start_f;
          self.filter.date_end = self.return.date_end_f;
          self.filter.capacity = self.return.participants.length;
          self.users_added = self.return.participants;
          self.schedule = self.return;
        })
        .catch((error) => {
          self.errors = error.response.data;
          self.$message(null, self.errors, "error");
        });
    },
    getServiceAdditionals: function () {
      let self = this;
      let id = self.$route.params.id;
      let api = self.$store.state.api + "services_additionals/";

      let fd = self.makeFormData();

      self.$http
        .get(api, fd)
        .then((response) => {
          self.services_additionals = response.data.data;
        })
        .catch((error) => {
          self.errors = error.response.data;
          self.$message(null, self.errors, "error");
        });
    },
    getCompanies() {
      const self = this;
      const api =
        self.$store.state.api +
        "companies/?paginated=false&with[]=branches&with[]=rooms";
      self.$http
        .get(api)
        .then((response) => {
          self.companies = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
  },
  mounted() {
    this.getDetails();
    this.getUsers();
    this.getEntity();
    this.getCompanies();
    this.getServiceAdditionals();
  },
};
</script>

<style scoped>
.title {
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 25px;
}
.card-img-top {
  max-width: 100%;
  height: 100%;
}

.card-room {
  max-height: 300px;
  overflow-y: hidden;
}

.VuePagination {
  text-align: center;
}

.lg-check {
  margin: 10px;
}

.lg-badge {
  margin: 3px;
}

.pointer {
  cursor: pointer;
}

.room-pic {
  width: 100%;
  overflow: hidden;
}

.borderSelected {
  border: 2px solid #4b2e8f;
  margin-bottom: 1rem;
  box-shadow: inset 0 0 1em #4b2e8f, 0 0 1em #4b2e8f;
}

.rowTable {
  padding: 3px;
  width: 100%;
}

.rowTable:hover {
  padding: 3px;
  width: 100%;
}

input[class="custom-check"] {
  position: absolute;
  z-index: -1;
  opacity: 0;
}

input[class="custom-check"] + label {
  font-size: 12px;
  padding: 2px 10px 0;
  width: 100%;
  max-height: 100%;
  border: 2px solid #4b2e8f;
  border-radius: 0.25rem;
}

input[class="custom-check"]:checked + label {
  border: 2px solid #4b2e8f;
  color: #fff;
  background-color: #4b2e8f;
  font-style: normal;
}
label {
  font-weight: 600;
  color: #222;
}
</style>


// WEBPACK FOOTER //
// src/components/ScheduleRooms/Edit.vue